module.exports = __webpack_public_path__ + "img/win_icon.4b5164a9.svg";